import styled from "styled-components";
import { Row } from "react-bootstrap";
import { MDBBtn } from 'mdb-react-ui-kit';

export const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 95%;
`;

export const Header = styled.div`
    padding-top: 15px;
    padding-left: 20px;
    padding-bottom: 10px;
    font-size: 20px;
    font-weight: bold;
    color: #616161;
    display: flex;
    flex-direction: column;
`;

export const Body = styled.div`
    margin-left: 70px;
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    width: 100%;
    @media (max-width: 850px) {
        margin: 0;
    }
`;

export const BodyContainer = styled(Row)`
    justify-content: start;
    @media (max-width: 899px) {
        justify-content: center;
    }
`;

export const Tab = styled.button`
    padding-bottom: 20px;
    padding-top: 20px;
    cursor: pointer;
    opacity: 0.6;
    border: 0;
    outline: 0;
    border-bottom: 2px solid transparent;
    transition: ease border-bottom 250ms;
    width: 45%;
    background-color: #FAFAFA;
    border-radius: 7px;
    &:hover {
        transition: all 0.3s ease-in-out;
        background-color: #F0F0F0;
    }
    text-align: center;
    ${({ active }) =>
        active &&
        `
        border-bottom: 2px solid black;
        opacity: 1;
        &:hover {
            transition: all 0.3s ease-in-out;
            background-color: #FAFAFA;
        }
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
        `
    }
`;

export const TableButton = styled(MDBBtn)`
    width: 50px;
    height: 35px;
    padding: 2px;
`